import React, { useState } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { Button } from "@heroui/react";

const LegacyDownloadButton = ({ endpoint, files, fileName}) => {
    const [isLoading, setIsLoading] = useState(false); // Estado para mostrar si el botón está ocupado

    const handleDownloadZip = async () => {
        if (!files) return;



        setIsLoading(true); // Iniciar estado de cargando (ocupado)
        const zip = new JSZip();

        try {
            const fileNameMap = {}; // Mapa para rastrear nombres duplicados

            // Extraer rutas y nombres de archivos de documents e images
            const allFiles = [
                ...files.documents.map((doc) => {
                    const filename = doc.archivo_ruta.split('/').pop(); // Extraer el nombre del archivo
                    return { filename, fullPath: doc.archivo_ruta };
                }),
                ...files.images.map((img) => {
                    const filename = img.imagen_ruta_grande.split('/').pop(); // Extraer el nombre del archivo
                    return { filename, fullPath: img.imagen_ruta_grande };
                }),
            ];


            // Obtener los archivos y añadirlos al ZIP
            const filePromises =
                allFiles.map(async (file) => {
                const response = await fetch(`${endpoint}${file.fullPath}`);
                const blob = await response.blob();

                let cleanName = file.filename;

                // Manejar nombres duplicados
                let uniqueFileName = cleanName;
                if (fileNameMap[cleanName]) {
                    // Si ya existe, agregar un sufijo único
                    const count = fileNameMap[cleanName] + 1;
                    uniqueFileName = `${cleanName.replace(/\.(\w+)$/, `(${count}).$1`)}`; // example: file(1).txt
                    fileNameMap[cleanName] = count; // Actualizar contador
                } else {
                    // Si no existe, inicializar en el mapa
                    fileNameMap[cleanName] = 1;
                }

                zip.file(uniqueFileName, blob); // Añadir el archivo al ZIP con el nombre único
            });

            // Esperar todas las descargas
            await Promise.all(filePromises);

            // Generar el ZIP y descargarlo
            const zipContent = await zip.generateAsync({ type: "blob" });
            saveAs(zipContent, `${fileName}-adjuntos.zip`);
        } catch (error) {
            console.error("Error al generar el ZIP:", error);
        } finally {
            setIsLoading(false); // Finalizar estado de cargando
        }

    };

    return (
        <Button
            color="primary"
            onPress={handleDownloadZip}
            isBusy={isLoading} // Si el componente tiene un prop "isBusy", úsalo
            disabled={isLoading} // Deshabilitar el botón mientras está ocupado
        >
            {isLoading ? "Procesando..." : "Descargar archivos como ZIP"}
        </Button>
    );
};

export default LegacyDownloadButton;